/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Partnercompanyids2Inputs */

const en__field_partnercompanyids2 = /** @type {(inputs: _Field_Partnercompanyids2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partner companies`)
};

/**
* | output |
* | --- |
* | "Partner companies" |
*
* @param {_Field_Partnercompanyids2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_partnercompanyids2 = /** @type {((inputs?: _Field_Partnercompanyids2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Partnercompanyids2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_partnercompanyids2(inputs)
});
export { _field_partnercompanyids2 as "_field_partnerCompanyIds" }